function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Constants and utilities for encoding channels (Visual variables)
 * such as 'x', 'y', 'color'.
 */
import { hasOwnProperty } from 'vega-util';
import { keys } from './util';
// Facet
export var ROW = 'row';
export var COLUMN = 'column';
export var FACET = 'facet';
// Position
export var X = 'x';
export var Y = 'y';
export var X2 = 'x2';
export var Y2 = 'y2';
// Position Offset
export var XOFFSET = 'xOffset';
export var YOFFSET = 'yOffset';
// Arc-Position
export var RADIUS = 'radius';
export var RADIUS2 = 'radius2';
export var THETA = 'theta';
export var THETA2 = 'theta2';
// Geo Position
export var LATITUDE = 'latitude';
export var LONGITUDE = 'longitude';
export var LATITUDE2 = 'latitude2';
export var LONGITUDE2 = 'longitude2';
// Time
export var TIME = 'time';
// Mark property with scale
export var COLOR = 'color';
export var FILL = 'fill';
export var STROKE = 'stroke';
export var SHAPE = 'shape';
export var SIZE = 'size';
export var ANGLE = 'angle';
export var OPACITY = 'opacity';
export var FILLOPACITY = 'fillOpacity';
export var STROKEOPACITY = 'strokeOpacity';
export var STROKEWIDTH = 'strokeWidth';
export var STROKEDASH = 'strokeDash';
// Non-scale channel
export var TEXT = 'text';
export var ORDER = 'order';
export var DETAIL = 'detail';
export var KEY = 'key';
export var TOOLTIP = 'tooltip';
export var HREF = 'href';
export var URL = 'url';
export var DESCRIPTION = 'description';
var POSITION_CHANNEL_INDEX = {
  x: 1,
  y: 1,
  x2: 1,
  y2: 1
};
var POLAR_POSITION_CHANNEL_INDEX = {
  theta: 1,
  theta2: 1,
  radius: 1,
  radius2: 1
};
export function isPolarPositionChannel(c) {
  return hasOwnProperty(POLAR_POSITION_CHANNEL_INDEX, c);
}
var GEO_POSIITON_CHANNEL_INDEX = {
  longitude: 1,
  longitude2: 1,
  latitude: 1,
  latitude2: 1
};
export function getPositionChannelFromLatLong(channel) {
  switch (channel) {
    case LATITUDE:
      return 'y';
    case LATITUDE2:
      return 'y2';
    case LONGITUDE:
      return 'x';
    case LONGITUDE2:
      return 'x2';
  }
}
export function isGeoPositionChannel(c) {
  return hasOwnProperty(GEO_POSIITON_CHANNEL_INDEX, c);
}
export var GEOPOSITION_CHANNELS = keys(GEO_POSIITON_CHANNEL_INDEX);
var UNIT_CHANNEL_INDEX = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, POSITION_CHANNEL_INDEX), POLAR_POSITION_CHANNEL_INDEX), GEO_POSIITON_CHANNEL_INDEX), {}, {
  xOffset: 1,
  yOffset: 1,
  // color
  color: 1,
  fill: 1,
  stroke: 1,
  // time
  time: 1,
  // other non-position with scale
  opacity: 1,
  fillOpacity: 1,
  strokeOpacity: 1,
  strokeWidth: 1,
  strokeDash: 1,
  size: 1,
  angle: 1,
  shape: 1,
  // channels without scales
  order: 1,
  text: 1,
  detail: 1,
  key: 1,
  tooltip: 1,
  href: 1,
  url: 1,
  description: 1
});
export function isColorChannel(channel) {
  return channel === COLOR || channel === FILL || channel === STROKE;
}
var FACET_CHANNEL_INDEX = {
  row: 1,
  column: 1,
  facet: 1
};
export var FACET_CHANNELS = keys(FACET_CHANNEL_INDEX);
var CHANNEL_INDEX = _objectSpread(_objectSpread({}, UNIT_CHANNEL_INDEX), FACET_CHANNEL_INDEX);
export var CHANNELS = keys(CHANNEL_INDEX);
var _o = CHANNEL_INDEX.order,
  _d = CHANNEL_INDEX.detail,
  _tt1 = CHANNEL_INDEX.tooltip,
  SINGLE_DEF_CHANNEL_INDEX = _objectWithoutProperties(CHANNEL_INDEX, ["order", "detail", "tooltip"]);
var _r = SINGLE_DEF_CHANNEL_INDEX.row,
  _c = SINGLE_DEF_CHANNEL_INDEX.column,
  _f = SINGLE_DEF_CHANNEL_INDEX.facet,
  SINGLE_DEF_UNIT_CHANNEL_INDEX = _objectWithoutProperties(SINGLE_DEF_CHANNEL_INDEX, ["row", "column", "facet"]);
/**
 * Channels that cannot have an array of channelDef.
 * model.fieldDef, getFieldDef only work for these channels.
 *
 * (The only two channels that can have an array of channelDefs are "detail" and "order".
 * Since there can be multiple fieldDefs for detail and order, getFieldDef/model.fieldDef
 * are not applicable for them. Similarly, selection projection won't work with "detail" and "order".)
 */
export var SINGLE_DEF_CHANNELS = keys(SINGLE_DEF_CHANNEL_INDEX);
export var SINGLE_DEF_UNIT_CHANNELS = keys(SINGLE_DEF_UNIT_CHANNEL_INDEX);
export function isSingleDefUnitChannel(str) {
  return hasOwnProperty(SINGLE_DEF_UNIT_CHANNEL_INDEX, str);
}
export function isChannel(str) {
  return hasOwnProperty(CHANNEL_INDEX, str);
}
export var SECONDARY_RANGE_CHANNEL = [X2, Y2, LATITUDE2, LONGITUDE2, THETA2, RADIUS2];
export function isSecondaryRangeChannel(c) {
  var main = getMainRangeChannel(c);
  return main !== c;
}
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */
export function getMainRangeChannel(channel) {
  switch (channel) {
    case X2:
      return X;
    case Y2:
      return Y;
    case LATITUDE2:
      return LATITUDE;
    case LONGITUDE2:
      return LONGITUDE;
    case THETA2:
      return THETA;
    case RADIUS2:
      return RADIUS;
  }
  return channel;
}
export function getVgPositionChannel(channel) {
  if (isPolarPositionChannel(channel)) {
    switch (channel) {
      case THETA:
        return 'startAngle';
      case THETA2:
        return 'endAngle';
      case RADIUS:
        return 'outerRadius';
      case RADIUS2:
        return 'innerRadius';
    }
  }
  return channel;
}
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */
export function getSecondaryRangeChannel(channel) {
  switch (channel) {
    case X:
      return X2;
    case Y:
      return Y2;
    case LATITUDE:
      return LATITUDE2;
    case LONGITUDE:
      return LONGITUDE2;
    case THETA:
      return THETA2;
    case RADIUS:
      return RADIUS2;
  }
  return undefined;
}
export function getSizeChannel(channel) {
  switch (channel) {
    case X:
    case X2:
      return 'width';
    case Y:
    case Y2:
      return 'height';
  }
  return undefined;
}
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */
export function getOffsetChannel(channel) {
  switch (channel) {
    case X:
      return 'xOffset';
    case Y:
      return 'yOffset';
    case X2:
      return 'x2Offset';
    case Y2:
      return 'y2Offset';
    case THETA:
      return 'thetaOffset';
    case RADIUS:
      return 'radiusOffset';
    case THETA2:
      return 'theta2Offset';
    case RADIUS2:
      return 'radius2Offset';
  }
  return undefined;
}
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */
export function getOffsetScaleChannel(channel) {
  switch (channel) {
    case X:
      return 'xOffset';
    case Y:
      return 'yOffset';
  }
  return undefined;
}
export function getMainChannelFromOffsetChannel(channel) {
  switch (channel) {
    case 'xOffset':
      return 'x';
    case 'yOffset':
      return 'y';
  }
}
// CHANNELS without COLUMN, ROW
export var UNIT_CHANNELS = keys(UNIT_CHANNEL_INDEX);
// NONPOSITION_CHANNELS = UNIT_CHANNELS without X, Y, X2, Y2;
var _x = UNIT_CHANNEL_INDEX.x,
  _y = UNIT_CHANNEL_INDEX.y,
  _x2 = UNIT_CHANNEL_INDEX.x2,
  _y2 = UNIT_CHANNEL_INDEX.y2,
  _xo = UNIT_CHANNEL_INDEX.xOffset,
  _yo = UNIT_CHANNEL_INDEX.yOffset,
  _latitude = UNIT_CHANNEL_INDEX.latitude,
  _longitude = UNIT_CHANNEL_INDEX.longitude,
  _latitude2 = UNIT_CHANNEL_INDEX.latitude2,
  _longitude2 = UNIT_CHANNEL_INDEX.longitude2,
  _theta = UNIT_CHANNEL_INDEX.theta,
  _theta2 = UNIT_CHANNEL_INDEX.theta2,
  _radius = UNIT_CHANNEL_INDEX.radius,
  _radius2 = UNIT_CHANNEL_INDEX.radius2,
  NONPOSITION_CHANNEL_INDEX = _objectWithoutProperties(UNIT_CHANNEL_INDEX, ["x", "y", "x2", "y2", "xOffset", "yOffset", "latitude", "longitude", "latitude2", "longitude2", "theta", "theta2", "radius", "radius2"]);
export var NONPOSITION_CHANNELS = keys(NONPOSITION_CHANNEL_INDEX);
var POSITION_SCALE_CHANNEL_INDEX = {
  x: 1,
  y: 1
};
export var POSITION_SCALE_CHANNELS = keys(POSITION_SCALE_CHANNEL_INDEX);
export function isXorY(channel) {
  return hasOwnProperty(POSITION_SCALE_CHANNEL_INDEX, channel);
}
export var POLAR_POSITION_SCALE_CHANNEL_INDEX = {
  theta: 1,
  radius: 1
};
export var POLAR_POSITION_SCALE_CHANNELS = keys(POLAR_POSITION_SCALE_CHANNEL_INDEX);
export function getPositionScaleChannel(sizeType) {
  return sizeType === 'width' ? X : Y;
}
var OFFSET_SCALE_CHANNEL_INDEX = {
  xOffset: 1,
  yOffset: 1
};
export var OFFSET_SCALE_CHANNELS = keys(OFFSET_SCALE_CHANNEL_INDEX);
export function isXorYOffset(channel) {
  return hasOwnProperty(OFFSET_SCALE_CHANNEL_INDEX, channel);
}
var TIME_SCALE_CHANNEL_INDEX = {
  time: 1
};
export var TIME_SCALE_CHANNELS = keys(TIME_SCALE_CHANNEL_INDEX);
export function isTime(channel) {
  return channel in TIME_SCALE_CHANNEL_INDEX;
}
// NON_POSITION_SCALE_CHANNEL = SCALE_CHANNELS without position / offset
var _t = NONPOSITION_CHANNEL_INDEX.text,
  _tt = NONPOSITION_CHANNEL_INDEX.tooltip,
  _hr = NONPOSITION_CHANNEL_INDEX.href,
  _u = NONPOSITION_CHANNEL_INDEX.url,
  _al = NONPOSITION_CHANNEL_INDEX.description,
  _dd = NONPOSITION_CHANNEL_INDEX.detail,
  _k = NONPOSITION_CHANNEL_INDEX.key,
  _oo = NONPOSITION_CHANNEL_INDEX.order,
  NONPOSITION_SCALE_CHANNEL_INDEX = _objectWithoutProperties(NONPOSITION_CHANNEL_INDEX, ["text", "tooltip", "href", "url", "description", "detail", "key", "order"]);
export var NONPOSITION_SCALE_CHANNELS = keys(NONPOSITION_SCALE_CHANNEL_INDEX);
export function isNonPositionScaleChannel(channel) {
  return hasOwnProperty(NONPOSITION_CHANNEL_INDEX, channel);
}
/**
 * @returns whether Vega supports legends for a particular channel
 */
export function supportLegend(channel) {
  switch (channel) {
    case COLOR:
    case FILL:
    case STROKE:
    case SIZE:
    case SHAPE:
    case OPACITY:
    case STROKEWIDTH:
    case STROKEDASH:
      return true;
    case FILLOPACITY:
    case STROKEOPACITY:
    case ANGLE:
    case TIME:
      return false;
  }
}
// Declare SCALE_CHANNEL_INDEX
var SCALE_CHANNEL_INDEX = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, POSITION_SCALE_CHANNEL_INDEX), POLAR_POSITION_SCALE_CHANNEL_INDEX), OFFSET_SCALE_CHANNEL_INDEX), NONPOSITION_SCALE_CHANNEL_INDEX);
/** List of channels with scales */
export var SCALE_CHANNELS = keys(SCALE_CHANNEL_INDEX);
export function isScaleChannel(channel) {
  return hasOwnProperty(SCALE_CHANNEL_INDEX, channel);
}
/**
 * Return whether a channel supports a particular mark type.
 * @param channel  channel name
 * @param mark the mark type
 * @return whether the mark supports the channel
 */
export function supportMark(channel, mark) {
  return getSupportedMark(channel)[mark];
}
var ALL_MARKS = {
  // all marks
  arc: 'always',
  area: 'always',
  bar: 'always',
  circle: 'always',
  geoshape: 'always',
  image: 'always',
  line: 'always',
  rule: 'always',
  point: 'always',
  rect: 'always',
  square: 'always',
  trail: 'always',
  text: 'always',
  tick: 'always'
};
var _g = ALL_MARKS.geoshape,
  ALL_MARKS_EXCEPT_GEOSHAPE = _objectWithoutProperties(ALL_MARKS, ["geoshape"]);
/**
 * Return a dictionary showing whether a channel supports mark type.
 * @param channel
 * @return A dictionary mapping mark types to 'always', 'binned', or undefined
 */
function getSupportedMark(channel) {
  switch (channel) {
    case COLOR:
    case FILL:
    case STROKE:
    // falls through
    case DESCRIPTION:
    case DETAIL:
    case KEY:
    case TOOLTIP:
    case HREF:
    case ORDER: // TODO: revise (order might not support rect, which is not stackable?)
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
    case STROKEWIDTH:
    // falls through
    case FACET:
    case ROW: // falls through
    case COLUMN:
      return ALL_MARKS;
    case X:
    case Y:
    case XOFFSET:
    case YOFFSET:
    case LATITUDE:
    case LONGITUDE:
    case TIME:
      // all marks except geoshape. geoshape does not use X, Y -- it uses a projection
      return ALL_MARKS_EXCEPT_GEOSHAPE;
    case X2:
    case Y2:
    case LATITUDE2:
    case LONGITUDE2:
      return {
        area: 'always',
        bar: 'always',
        image: 'always',
        rect: 'always',
        rule: 'always',
        circle: 'binned',
        point: 'binned',
        square: 'binned',
        tick: 'binned',
        line: 'binned',
        trail: 'binned'
      };
    case SIZE:
      return {
        point: 'always',
        tick: 'always',
        rule: 'always',
        circle: 'always',
        square: 'always',
        bar: 'always',
        text: 'always',
        line: 'always',
        trail: 'always'
      };
    case STROKEDASH:
      return {
        line: 'always',
        point: 'always',
        tick: 'always',
        rule: 'always',
        circle: 'always',
        square: 'always',
        bar: 'always',
        geoshape: 'always'
      };
    case SHAPE:
      return {
        point: 'always',
        geoshape: 'always'
      };
    case TEXT:
      return {
        text: 'always'
      };
    case ANGLE:
      return {
        point: 'always',
        square: 'always',
        text: 'always'
      };
    case URL:
      return {
        image: 'always'
      };
    case THETA:
      return {
        text: 'always',
        arc: 'always'
      };
    case RADIUS:
      return {
        text: 'always',
        arc: 'always'
      };
    case THETA2:
    case RADIUS2:
      return {
        arc: 'always'
      };
  }
}
export function rangeType(channel) {
  switch (channel) {
    case X:
    case Y:
    case THETA:
    case RADIUS:
    case XOFFSET:
    case YOFFSET:
    case SIZE:
    case ANGLE:
    case STROKEWIDTH:
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
    case TIME:
    // X2 and Y2 use X and Y scales, so they similarly have continuous range. [falls through]
    case X2:
    case Y2:
    case THETA2:
    case RADIUS2:
      return undefined;
    case FACET:
    case ROW:
    case COLUMN:
    case SHAPE:
    case STROKEDASH:
    // TEXT, TOOLTIP, URL, and HREF have no scale but have discrete output [falls through]
    case TEXT:
    case TOOLTIP:
    case HREF:
    case URL:
    case DESCRIPTION:
      return 'discrete';
    // Color can be either continuous or discrete, depending on scale type.
    case COLOR:
    case FILL:
    case STROKE:
      return 'flexible';
    // No scale, no range type.
    case LATITUDE:
    case LONGITUDE:
    case LATITUDE2:
    case LONGITUDE2:
    case DETAIL:
    case KEY:
    case ORDER:
      return undefined;
  }
}